var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerMenuItem = void 0;
var DrawerMenuItem_1 = __importDefault(require("./DrawerMenuItem"));
exports.DrawerMenuItem = DrawerMenuItem_1.default;
exports.default = DrawerMenuItem_1.default;
//# sourceMappingURL=index.js.map